import {
  FormGroup,
  FormControl,
  AbstractControl,
  AsyncValidator,
  AsyncValidatorFn,
} from '@angular/forms';
import { IFormConfig } from '../models/formConfig.model';
import { Injector, signal, WritableSignal } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

export function generateForm(
  formConfig: IFormConfig,
  injector: Injector
): {
  form: FormGroup;
  displayConditionsChanges: Observable<any>[];
  hasAnyValue: boolean;
} {
  const form = new FormGroup({}, { updateOn: 'change' });
  const displayConditionsChanges: Observable<any>[] = [];

  let hasAnyValue = false;

  formConfig.sections.forEach((formSection) => {
    // if (formSection?.skipFormSection) return;
    const sectionGroup = new FormGroup({}, formSection.validators);
    formSection.fields.forEach((field) => {
      // if (field.type === FormFieldTypeEnum.INFORMATION) return;
      const validators: any = {};
      if (field.validators) {
        validators.validators = field.validators;
      }

      if (field.asyncValidators?.length) {
        validators.asyncValidators = field.asyncValidators.map(
          (av: any): AsyncValidatorFn => {
            // injector.get<AsyncValidator>(av).validate.bind(injector.get(av)),
            const validator = injector.get(av) as AsyncValidator;
            return validator.validate.bind(validator);
          }
        );
      }
      if (field?.value !== undefined) {
        hasAnyValue = true;
      }
      const ctrl = new FormControl(field?.value, {
        validators: validators.validators,
        updateOn: 'change',
      });
      (ctrl as any).uuid = uuidv4();
      (ctrl as any).name = field.name;
      (ctrl as any).hint = signal(null) as WritableSignal<any>;

      if (field.disabled) {
        ctrl.disable();
      }

      if (field?.asyncValidators?.length) {
        ctrl.setAsyncValidators(validators.asyncValidators);
        ctrl.updateValueAndValidity({ emitEvent: true });
      }

      sectionGroup.addControl(field.name, ctrl);
    });
    form.addControl(formSection.groupName, sectionGroup);
  });

  formConfig.sections.forEach((formSection) => {
    formSection.fields.forEach((field) => {
      const expectedStatusListener = field.displayConditions?.find(
        (dc) => dc.watchStatusChanges
      );
      if (expectedStatusListener) {
        const interestedField = extractFormControl(
          expectedStatusListener.field,
          form
        );
        const obs$ = interestedField!.statusChanges;

        displayConditionsChanges.push(obs$);
      }
    });
  });

  return { form, displayConditionsChanges, hasAnyValue };
}

export function extractFormControl(
  path: string,
  form: FormGroup<any> | AbstractControl<any> | FormControl | null
) {
  const pathSplitted = path.split('.');

  let current: FormGroup<any> | AbstractControl<any> | FormControl | null =
    form;

  pathSplitted.forEach((p) => {
    if (current) {
      current = getFormControl(p, current);
    }
  });

  return current;
}

export function getFormControl(
  path: string,
  form: FormGroup | AbstractControl
) {
  return form.get(path);
}
